import { useEffect } from "react"

import { updateSystemFavicon } from "../lib/favicon"

/** Mount once in the document shell, including pages without a Trail icon. */
export function useSystemFavicon() {
  useEffect(() => {
    const query = window.matchMedia("(prefers-color-scheme: dark)")
    updateSystemFavicon()
    query.addEventListener("change", updateSystemFavicon)
    return () => query.removeEventListener("change", updateSystemFavicon)
  }, [])
}
